import { Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { LoginGuard } from './auth/login.guard';
import { Layout } from './components/layout/layout';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    canActivate: [LoginGuard],
    loadComponent: () =>
      import('./components/login/login').then(m => m.login)
  },
  {
    path: '',
    component: Layout,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./components/dashboard/dashboard').then(m => m.Dashboard)
      },
      {
        path: 'usermanagement',
        loadComponent: () => import('./components/user-management/user-management').then(m => m.UserManagement)
      },
      {
        path: 'viewusermanagement/:id',
        loadComponent: () => import('./components/view-user-management/view-user-management').then(m => m.ViewUserManagement)
      },
      {
        path: 'categorymanagement',
        loadComponent: () => import('./components/category-management/category-management').then(m => m.CategoryManagement)
      },
      {
        path: 'add-category-management',
        loadComponent: () => import('./components/view-category-management/view-category-management').then(m => m.ViewCategoryManagement)
      },

      {
        path: 'edit-category-management/:id',
        loadComponent: () => import('./components/view-category-management/view-category-management').then(m => m.ViewCategoryManagement)
      },

      {
        path: 'marketmanagement',
        loadComponent: () => import('./components/market-management/market-management').then(m => m.MarketManagement)
      },
      {
        path: 'addmarket',
        loadComponent: () =>
          import('./components/add-market-management/add-market-management').then(m => m.AddMarketManagement)
      },
      {
        path: 'editmarket/:id',
        loadComponent: () =>
          import('./components/add-market-management/add-market-management').then(m => m.AddMarketManagement)
      },

      {
        path: 'marketapprovalmanagement',
        loadComponent: () => import('./components/market-approval-management/market-approval-management').then(m => m.MarketApprovalManagement)
      },
      {
        path: 'rejectedmarkets',
        loadComponent: () => import('./components/rejected-markets/rejected-markets').then(m => m.RejectedMarkets)
      },
      {
        path: 'settings',
        loadComponent: () => import('./components/settings/settings').then(m => m.Settings)
      },
      {
        path: '**',
        loadComponent: () => import('./components/shared/page-not-found/page-not-found').then(m => m.PageNotFound)

      }
    ]
  }
];

